import React from 'react'
import styled, { keyframes } from 'styled-components'

const CompetitionVotesSkeleton: React.FC = () => (
  <>
    <HeaderSkeleton>
      <HeaderContent>
        <SkeletonBox width="24px" height="24px" borderRadius="4px" />
        <SkeletonBox width="120px" height="20px" />
      </HeaderContent>
    </HeaderSkeleton>

    <SkeletonContainer>
      <ProgressSkeleton>
        <SkeletonCircle size="80px" />
        <SkeletonBox width="100px" height="14px" />
      </ProgressSkeleton>

      <CardSkeleton>
        <CardHeaderSkeleton />
        <TeamsSection>
          <SkeletonCircle size="60px" />
          <SkeletonBox width="40px" height="24px" />
          <SkeletonCircle size="60px" />
        </TeamsSection>
        <ButtonsSection>
          <SkeletonBox width="100%" height="50px" borderRadius="12px" />
          <SkeletonBox width="100%" height="50px" borderRadius="12px" />
        </ButtonsSection>
        <SkeletonBox width="100%" height="50px" borderRadius="12px" style={{ marginTop: '12px' }} />
      </CardSkeleton>
    </SkeletonContainer>
  </>
)

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`

const HeaderSkeleton = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  max-width: 600px;
  margin: 0 auto;
  height: 211px;
  background: linear-gradient(90deg, var(--zinc-800) 25%, var(--zinc-700) 50%, var(--zinc-800) 75%);
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  z-index: 100;

  @media (max-width: 600px) {
    max-width: 100%;
  }
`

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  padding-top: 50px;
`

const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 231px;

  @media (max-width: 400px) {
    padding-top: 155px;
  }
`

const ProgressSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
`

const CardSkeleton = styled.div`
  max-width: 350px;
  width: calc(100% - 40px);
  background: var(--bg-decimary);
  border-radius: 16px;
  padding: 40px 30px;
  margin-top: 230px;

  @media (max-width: 400px) {
    max-width: 280px;
    padding: 30px 24px;
    margin-top: 175px;
  }
`

const CardHeaderSkeleton = styled.div`
  width: 100%;
  height: 80px;
  border-radius: 8px;
  background: linear-gradient(90deg, var(--zinc-800) 25%, var(--zinc-700) 50%, var(--zinc-800) 75%);
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
  margin-bottom: 16px;
`

const TeamsSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px 0;
  padding: 0 20px;
`

const ButtonsSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`

const SkeletonBox = styled.div<{
  width?: string;
  height?: string;
  borderRadius?: string;
  style?: React.CSSProperties;
}>`
  width: ${props => props.width || '100%'};
  height: ${props => props.height || '20px'};
  border-radius: ${props => props.borderRadius || '4px'};
  background: linear-gradient(90deg, var(--zinc-800) 25%, var(--zinc-700) 50%, var(--zinc-800) 75%);
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
`

const SkeletonCircle = styled.div<{ size?: string }>`
  width: ${props => props.size || '60px'};
  height: ${props => props.size || '60px'};
  border-radius: 50%;
  background: linear-gradient(90deg, var(--zinc-800) 25%, var(--zinc-700) 50%, var(--zinc-800) 75%);
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
`

export default CompetitionVotesSkeleton
